// @flow

import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import PinnerImage from 'app/common/react/components/growth/unauth/Image/Image';
import PropTypes from 'prop-types';
import { getUserFullName } from 'app/common/react/components/growth/unauth/pin/pinUtils';
import { Text } from 'gestalt';

type Props = {
  board: {
    url: string,
    name: string,
  },
  pinner: {
    image_small_url: string,
    image_large_url: string,
    full_name: string,
    username: string,
  },
  inSemanticGroup?: boolean,
  inRemoveInlineGroup?: boolean,
};

const styles = {
  pinnerDescription: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',
  },
  pinnerImage: {
    borderRadius: '50%',
    position: 'relative',
    float: 'left',
    height: '24px',
    width: '24px',
    display: 'block',
    marginRight: '4px',
  },
  pinDescription_text: {
    color: '#333',
    fontSize: '12px',
    fontWeight: 'normal',
    letterspacing: '-.4px',
    margin: '0px',
    overflow: 'hidden',
    padding: '0 4px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '160px',
  },
  avatar: {
    borderRadius: '50%',
    WebkitBoxShadow: '0 0 2px rgba(0,0,0,0.33) inset',
    boxShadow: '0 0 2px rgba(0,0,0,0.33) inset',
    content: ' ',
    height: '24px',
    left: '0',
    position: 'absolute',
    top: '0',
    width: '24px',
    marginLeft: '4px',
    marginRight: '4px',
  },
};

const renderPinnerImagePlaceholder = (inRemoveInlineGroup) => (
  <span
    className="pinDescriptionPinner__image"
    style={inRemoveInlineGroup ? null : styles.avatar}
  />
);

const PinnerBoardAttribution = (props: Props) => {
  const { pinner, board, inRemoveInlineGroup } = props;
  if (!pinner || !board) {
    return null;
  }
  const imgSrc = pinner.image_small_url || pinner.image_large_url;
  const imgAlt = pinner.full_name || pinner.username;
  const pinnerDisplayName = getUserFullName(board, pinner);
  const username = board.url ? board.url.split('/')[1] : '';

  return (
    <div
      className="pinDescription_pinnerBoardAttribution"
      style={inRemoveInlineGroup ? null : styles.pinnerDescription}
    >
      <NavigateLink className="underlineLink" stopPropagation to={`/${username}/`}>
        <PinnerImage
          alt={imgAlt}
          lazyLoad={false}
          className={inRemoveInlineGroup ? 'pinDescription_pinnerProfileImage' : null}
          renderPlaceholder={() => renderPinnerImagePlaceholder(inRemoveInlineGroup)}
          src={imgSrc}
          style={inRemoveInlineGroup ? null : styles.pinnerImage}
          useBackgroundImage
        />
      </NavigateLink>
      <div className="pinDescription_attribute_container">
        {board &&
          username &&
          (inRemoveInlineGroup ? (
            <NavigateLink
              className="underlineLink pinDescription_text"
              style={
                inRemoveInlineGroup
                  ? { fontWeight: 'bolder' }
                  : { ...styles.pinDescription_text, fontWeight: 'bolder' }
              }
              stopPropagation
              to={`/${username}/`}
            >
              {pinnerDisplayName}
            </NavigateLink>
          ) : (
            <div
              className="pinDescription_text"
              style={
                inRemoveInlineGroup
                  ? { fontWeight: 'bolder' }
                  : { ...styles.pinDescription_text, fontWeight: 'bolder' }
              }
            >
              <NavigateLink className="underlineLink" stopPropagation to={`/${username}/`}>
                <Text truncate size="xs" bold>
                  {pinnerDisplayName}
                </Text>
              </NavigateLink>
            </div>
          ))}
        {board &&
          board.name &&
          board.url &&
          (inRemoveInlineGroup ? (
            <NavigateLink
              className="pinDescription_text pinDescription_text_board underlineLink"
              style={inRemoveInlineGroup ? null : styles.pinDescription_text}
              stopPropagation
              to={board.url}
            >
              {board.name}
            </NavigateLink>
          ) : (
            <div
              className="pinDescription_text"
              style={inRemoveInlineGroup ? null : styles.pinDescription_text}
            >
              <NavigateLink className="underlineLink" stopPropagation to={board.url}>
                <Text truncate size="xs">
                  {board.name}
                </Text>
              </NavigateLink>
            </div>
          ))}
      </div>
    </div>
  );
};

PinnerBoardAttribution.propTypes = {
  board: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  pinner: PropTypes.shape({
    image_small_url: PropTypes.string,
    image_large_url: PropTypes.string,
    full_name: PropTypes.string,
    username: PropTypes.string,
  }),
  inSemanticGroup: PropTypes.bool,
  inRemoveInlineGroup: PropTypes.bool,
};

export default PinnerBoardAttribution;
